import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { ReactComponent as YesIcon } from '../../../../assets/images/checkmark.svg';
import styles from './PlanOptions.module.css';
import { Row } from 'reactstrap';
import classnames from 'classnames';
import { getBrandContent } from '../../../BrandingWhiteLabel/BrandContent';
import { useContext } from 'react';
import { SessionContext } from '../../../../context/SessionContext';
import { getWorkerType } from '../../../../lib/util';

const coverageTypeTable = styles.coverageTypeTable;

const YesIconComp = () => {
    return (
        <div className={styles.yesIcon}>
            <YesIcon />
        </div>
    );
};

const CoverageType = () => {
    const context = useContext(SessionContext);
    const { accountName } = context;
    const accountNameToLower = accountName.toLowerCase();
    const categoryWorker = getWorkerType(context?.getProfile()?.countryId);

    let screenRecords = getBrandContent('coveragetype');
    let coverageTypeColumnsAll = [];
    let coverageTypeDataAll = [];
    const getCoverageType = (coveragecolumn) => {
        return coveragecolumn === 'Labor Costs' ? `${categoryWorker} Costs` : coveragecolumn;
    };

    function widthFormatter1(width) {
        const widths = {
            planCol: '40%',
            laborCol: '30%',
            partsCol: '30%'
        };

        return {
            width: widths[width]
        };
    }

    function widthFormatter2(width) {
        const widths = {
            planCol: '40%',
            laborCol: '20%',
            laborPlusCol: '20%',
            partsCol: '20%'
        };

        return {
            width: widths[width]
        };
    }

    function widthFormatter3(width) {
        const widths = {
            planCol: '35%',
            laborCol: '15%',
            laborPlusCol: '15%',
            laborPartsCol: '20%',
            partsCol: '15%'
        };

        return {
            width: widths[width]
        };
    }

    function widthFormatter4(width) {
        const widths = {
            planCol: '50%',
            laborCol: '50%'
        };

        return {
            width: widths[width]
        };
    }

    if (accountNameToLower === 'rheem' && (screenRecords[accountNameToLower]?.plan1?.length ?? 0) === 3) {
        coverageTypeColumnsAll = [
            {
                dataField: 'planBenefits',
                text: 'Plan Benefits*',
                headerStyle: widthFormatter1('planCol'),
                style: widthFormatter1('planCol')
            },
            {
                dataField: 'laborOnly',
                text: `${categoryWorker} Only`,
                headerStyle: widthFormatter1('laborCol'),
                style: widthFormatter1('laborCol')
            },
            {
                dataField: 'parts',
                text: 'Parts',
                headerStyle: widthFormatter1('partsCol'),
                style: widthFormatter1('partsCol')
            }
        ];

        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan1
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan1[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan1[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[1]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan1[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[2]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan2
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan2[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan2[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan2[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[1]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan2[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[2]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan3
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan3[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan3[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan3[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[1]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan3[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[2]
                    )
            });
    }

    if (accountNameToLower === 'nordyne' && (screenRecords[accountNameToLower]?.plan1?.length ?? 0) === 3) {
        coverageTypeColumnsAll = [
            {
                dataField: 'planBenefits',
                text: 'Plan Benefits*',
                headerStyle: widthFormatter1('planCol'),
                style: widthFormatter1('planCol')
            },
            {
                dataField: 'laborOnly',
                text: `${categoryWorker} Only`,
                headerStyle: widthFormatter1('laborCol'),
                style: widthFormatter1('laborCol')
            },
            {
                dataField: 'partsLabor',
                text: `Parts & ${categoryWorker}`,
                headerStyle: widthFormatter1('partsCol'),
                style: widthFormatter1('partsCol')
            }
        ];

        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan1
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan1[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan1[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[1]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan1[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[2]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan2
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan2[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan2[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan2[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[1]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan2[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[2]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan3
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan3[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan3[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[1]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan3[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[2]
                    )
            });
    }

    if (
        (screenRecords[accountNameToLower]?.plan1?.length ?? 0) > 3
        && (screenRecords[accountNameToLower]?.plan1?.length ?? 0) < 5
    ) {
        coverageTypeColumnsAll = [
            {
                dataField: 'planBenefits',
                text: 'Plan Benefits*',
                headerStyle: widthFormatter2('planCol'),
                style: widthFormatter2('planCol')
            },
            {
                dataField: 'laborOnly',
                text: `${categoryWorker} Only`,
                headerStyle: widthFormatter2('laborCol'),
                style: widthFormatter2('laborCol')
            },
            {
                dataField: 'laborPlus',
                text: `${categoryWorker} PLUS`,
                headerStyle: widthFormatter2('laborPlusCol'),
                style: widthFormatter2('laborPlusCol')
            },
            {
                dataField: 'parts',
                text: 'Parts',
                headerStyle: widthFormatter2('partsCol'),
                style: widthFormatter2('partsCol')
            }
        ];

        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan1
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan1[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan1[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan1[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan1[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[3]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan2
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan2[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan2[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan2[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan2[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan2[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[3]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan3
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan3[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan3[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan3[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan3[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan3[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[3]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan4
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan4[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan4[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan4[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan4[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[3]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan5
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan5[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan5[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan5[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan5[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[3]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan6
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan6[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan6[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan6[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan6[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[3]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan7
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan7[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan7[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan7[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[2]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan7[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[3]
                    )
            });
    }

    if (screenRecords[accountNameToLower]?.plan1.length >= 5) {
        coverageTypeColumnsAll = [
            {
                dataField: 'planBenefits',
                text: 'Plan Benefits*',
                headerStyle: widthFormatter3('planCol'),
                style: widthFormatter3('planCol')
            },
            {
                dataField: 'laborOnly',
                text: `${categoryWorker} Only`,
                headerStyle: widthFormatter3('laborCol'),
                style: widthFormatter3('laborCol')
            },
            {
                dataField: 'laborPlus',
                text: `${categoryWorker} PLUS`,
                headerStyle: widthFormatter3('laborPlusCol'),
                style: widthFormatter3('laborPlusCol')
            },
            {
                dataField: 'partsLabor',
                text: `Parts & ${categoryWorker} PLUS`,
                headerStyle: widthFormatter3('laborPartsCol'),
                style: widthFormatter3('laborPartsCol')
            },
            {
                dataField: 'parts',
                text: 'Parts Only',
                headerStyle: widthFormatter3('partsCol'),
                style: widthFormatter3('partsCol')
            }
        ];
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan1
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan1[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan1[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan1[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan1[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan1[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[4]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan2
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan2[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan2[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan2[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan2[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan2[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan2[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[4]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan3
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan3[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan3[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan3[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan3[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan3[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan3[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[4]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan4
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan4[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan4[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan4[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan4[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan4[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan4[4]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan5
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan5[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan5[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan5[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan5[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan5[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan5[4]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan6
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan6[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan6[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan6[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan6[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan6[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan6[4]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan7
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan7[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan7[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[1]
                    ),
                laborPlus:
                    screenRecords[accountNameToLower]?.plan7[2] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[2]
                    ),
                partsLabor:
                    screenRecords[accountNameToLower]?.plan7[3] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[3]
                    ),
                parts:
                    screenRecords[accountNameToLower]?.plan7[4] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan7[4]
                    )
            });
    }

    if (accountNameToLower === 'mainline' && (screenRecords[accountNameToLower]?.plan1?.length ?? 0) === 2) {
        coverageTypeColumnsAll = [
            {
                dataField: 'planBenefits',
                text: 'Plan Benefits*',
                headerStyle: widthFormatter4('planCol'),
                style: widthFormatter4('planCol')
            },
            {
                dataField: 'laborOnly',
                text: `${categoryWorker} Only`,
                headerStyle: widthFormatter4('laborCol'),
                style: widthFormatter4('laborCol')
            }
        ];

        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan1
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan1[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[0]
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan1[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan1[1]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan2
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan2[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan2[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan2[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan2[1]
                    )
            });
        screenRecords[accountNameToLower] !== null
            && screenRecords[accountNameToLower]?.plan3
            && coverageTypeDataAll.push({
                planBenefits:
                    screenRecords[accountNameToLower]?.plan3[0] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        getCoverageType(screenRecords[accountNameToLower]?.plan3[0])
                    ),
                laborOnly:
                    screenRecords[accountNameToLower]?.plan3[1] === 'yes' ? (
                        <YesIconComp />
                    ) : (
                        screenRecords[accountNameToLower]?.plan3[1]
                    )
            });
    }

    return (
        <>
            {accountNameToLower === 'ge' ? (
                <p>
                    Plan options will vary depending on the product and{' '}
                    {getBrandContent(accountName).pricingLevelName.toLowerCase()} selected.
                </p>
            ) : (
                <p>
                    Plan options will vary depending on the product and{' '}
                    {getBrandContent(accountName).pricingLevelName.toLowerCase()} selected.
                </p>
            )}

            {coverageTypeDataAll.length > 0 && (
                <div className={classnames(coverageTypeTable, 'm-lg-0')}>
                    <BootstrapTable
                        keyField='planBenefits'
                        data={coverageTypeDataAll}
                        columns={coverageTypeColumnsAll}
                        bordered={true}
                        bootstrap4
                        wrapperClasses='table-responsive-lg'
                    />
                </div>
            )}
            {accountNameToLower === 'lennox' ? (
                <p className='mt-3 mb-0'>
                    *Depending on the plan purchased, benefits will vary. Limitations and exclusions apply. Please see
                    the full terms and conditions for further details.
                </p>
            ) : (
                <p className='mt-3 mb-0'>
                    *Depending on the plan purchased, benefits will vary. Limitations and exclusions apply. Please see
                    the full terms and conditions for further details.
                </p>
            )}
        </>
    );
};

export default CoverageType;
